import type { ChangePasswordRequest } from '@jaf/contracts';
import { httpClient } from '@/shared/api';

/** AUTH-5: troca a senha do usuário logado (bearer); a API encerra as outras sessões. */
export async function changePassword(request: ChangePasswordRequest): Promise<void> {
  await httpClient.post('/auth/password', request);
}

/** AUTH-3: encerra todas as sessões do usuário, em todos os dispositivos (bearer). */
export async function logoutAllDevices(): Promise<void> {
  await httpClient.post('/auth/logout-all');
}
